import * as React from 'react'

import { styled } from '~/styled'

import { Image } from '../../image/Image'
import { useBannerContext } from '../BannerContext'

const Container = styled(
  'div',
  {
    base: ['overflow-hidden', 'rounded-full', 'self-start', 'shrink-0'],
    variants: {
      size: {
        sm: ['size-10'],
        md: ['size-12']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

const StyledImage = styled(Image, {
  base: ['max-w-none', 'size-full', 'object-cover']
})

export const BannerSlimImage = (
  props: React.ComponentPropsWithoutRef<typeof Image>
) => {
  const { size } = useBannerContext()

  return (
    <Container size={size}>
      <StyledImage {...props} />
    </Container>
  )
}

BannerSlimImage.displayName = 'BannerSlimImage'
